var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 3.73828C14.6094 2.08594 11.9355 2.08594 10.2852 3.73828L8.39258 5.63086L9.38867 6.62695L11.2812 4.73438C12.332 3.68359 14.1055 3.57227 15.2656 4.73438C16.4277 5.89648 16.3164 7.66797 15.2656 8.71875L13.373 10.6113L14.3711 11.6094L16.2637 9.7168C17.9121 8.06445 17.9121 5.39063 16.2617 3.73828ZM8.7207 15.2656C7.66992 16.3164 5.89648 16.4277 4.73633 15.2656C3.57422 14.1035 3.68555 12.332 4.73633 11.2813L6.62891 9.38867L5.63086 8.39063L3.73828 10.2832C2.08594 11.9355 2.08594 14.6094 3.73828 16.2598C5.39062 17.9102 8.06445 17.9121 9.71484 16.2598L11.6074 14.3672L10.6113 13.3711L8.7207 15.2656ZM5.08398 4.08984C5.05462 4.06077 5.01496 4.04445 4.97363 4.04445C4.9323 4.04445 4.89265 4.06077 4.86328 4.08984L4.08984 4.86328C4.06077 4.89265 4.04445 4.93231 4.04445 4.97363C4.04445 5.01496 4.06077 5.05462 4.08984 5.08398L14.918 15.9121C14.9785 15.9727 15.0781 15.9727 15.1387 15.9121L15.9121 15.1387C15.9727 15.0781 15.9727 14.9785 15.9121 14.918L5.08398 4.08984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon2);
export default __webpack_public_path__ + "static/media/disconnect_icon_2.598c7089658c3945295baad7aee7668a.svg";
export { ForwardRef as ReactComponent };